import { Dialog } from "./Dialog";

/** What the system will and will not do. Stated plainly, because trust depends on the limits. */
export function Guide({ onClose }: { onClose: () => void }) {
  return (
    <Dialog title="Guide" onClose={onClose} className="overlay-card">
        <div className="body" style={{ background: "var(--color-surface)" }}>
          <h4 style={{ marginBottom: 8 }}>What this does</h4>
          <p className="muted" style={{ fontSize: 14, marginBottom: 16 }}>
            Recovers what is actually installed from the original vendor documentation, and finds
            a replacement when a part is obsolete. Every value shows the page it came from.
          </p>
          <h4 style={{ marginBottom: 8 }}>What it will not do</h4>
          <ul style={{ marginLeft: 18 }}>
            {[
              "Guess. A field that is not on the page is reported as not stated in source.",
              "Settle a disagreement between two documents. Both values are shown and you choose.",
              "Call a part obsolete without a published notice saying so.",
              "Report a part as current because no notice was found. Those are different answers.",
              "Run a market search before you approve the specification.",
              "Email a vendor, request a quotation, or buy anything.",
            ].map((t) => <li key={t} style={{ fontSize: 14, lineHeight: 1.9, color: "var(--color-text-muted)" }}>{t}</li>)}
          </ul>
          <h4 style={{ margin: "16px 0 8px" }}>Why a value may need review</h4>
          <p className="muted" style={{ fontSize: 14 }}>
            Each page is read twice: once for the values, once for where they sit. Where the two
            readings disagree, or the value cannot be placed on the page, the field is flagged
            rather than presented as settled.
          </p>
        </div>
    </Dialog>
  );
}
